import {
  CHANGE_AUTH_FORM,
  SET_AUTH,
  SENDING_AUTH_REQUEST,
  REQUEST_AUTH_ERROR,
  CLEAR_AUTH_ERROR,
  SET_UNAUTHORIZED,
  SENDING_ACCOUNT_REGISTER,
  REGISTER_ACCOUNT_FAILURE,
  SENDING_FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_FAILURE,
  SENDING_VERIFY_CODE_RESET_PASSWORD_REQUEST,
  VERIFY_CODE_RESET_PASSWORD_FAILURE,
  SENDING_RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_FAILURE
} from '../actions/constants'

const initialState = {
  formState: {
    username: '',
    password: '',
    remember: false,
    nextUrl: '/'
  },
  error: '',
  fetching: false,
  loggedIn: false,
  nextUrl: '/'
}

const auth = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_AUTH_FORM:
      return {
        ...state,
        formState: action.newFormState
      }
    case SET_AUTH:
      return {
        ...state,
        fetching: false,
        loggedIn: action.newAuthState
      }
    case SENDING_AUTH_REQUEST:
    case SENDING_ACCOUNT_REGISTER:
    case SENDING_FORGOT_PASSWORD_REQUEST:
    case SENDING_VERIFY_CODE_RESET_PASSWORD_REQUEST:
    case SENDING_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        fetching: action.sending
      }
    case REQUEST_AUTH_ERROR:
    case REGISTER_ACCOUNT_FAILURE:
    case FORGOT_PASSWORD_FAILURE:
    case VERIFY_CODE_RESET_PASSWORD_FAILURE:
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case CLEAR_AUTH_ERROR:
      return {
        ...state,
        fetching: false,
        error: ''
      }
    case SET_UNAUTHORIZED:
      return {
        ...state,
        loggedIn: action.newAuthState
      }
    default:
      return state
  }
}

export default auth



// WEBPACK FOOTER //
// ./src/reducers/auth.js